import { Link } from 'react-router-dom';

interface NotificationBellProps {
  count: number;
  className?: string;
}

export function NotificationBell({ count, className = '' }: NotificationBellProps) {
  return (
    <Link
      to="/me/devices?tab=notifications"
      className={`relative flex items-center gap-2 rounded-full px-3 py-1.5 hover:bg-surface-700 transition-colors ${className}`}
      aria-label={`${count} devices need new batteries`}
    >
      <span className="relative shrink-0">
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
          <path d="M12.5 3a7.5 7.5 0 108.4 10.9A9 9 0 0112.5 3z" />
        </svg>
        {count > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-accent-red text-white text-[10px] font-bold flex items-center justify-center">
            {count}
          </span>
        )}
      </span>
      <span className="hidden md:inline text-xs text-neutral-300 whitespace-nowrap">
        {count > 0 ? `${count} ${count === 1 ? 'device needs' : 'devices need'} new batteries` : 'All batteries healthy'}
      </span>
    </Link>
  );
}
